import React from 'react';
import ClientApplicationList from '~/components/ClientApplication/ClientApplicationList';
import NavigationSidebar from '~/components/NavigationSidebar';
import BaseLayout from '~/layouts/BaseLayout';

class ClientApplicationListLayout extends BaseLayout {
  renderSidebar() {
    return <NavigationSidebar />;
  }

  renderMain() {
    const { route } = this.props;

    return <ClientApplicationList route={route} />;
  }
}

export default ClientApplicationListLayout;
